import React, { FC } from 'react'

import { IconCelebrateProps } from './IconCelebrate.types'
import * as Styled from './styles/IconCelebrate.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCelebrate: FC<IconCelebrateProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCelebrateProps['size'],
  isResponsive = false,
}: IconCelebrateProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m24 6 1.68 3.39 3.74.55-2.71 2.64.64 3.73L24 14.55l-3.35 1.76.64-3.73-2.71-2.64 3.74-.55L24 6Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m8.49 12.02 2.13 1.8 2.69-.72-1.06 2.58 1.53 2.34-2.79-.21-1.75 2.17-.66-2.71-2.61-1 2.38-1.46.14-2.79Zm31.02 0-2.13 1.8-2.69-.72 1.06 2.58-1.53 2.34 2.79-.21 1.75 2.17.66-2.71 2.61-1-2.38-1.46-.14-2.79Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M39.66 30.07a.35.35 0 0 1 .34-.35.34.34 0 1 1-.34.35Z' stroke='#EA1A1A' strokeMiterlimit='10' strokeWidth='2' />
        <path d='M8 33.06a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M38 39.06a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M32.67 43.11a.34.34 0 0 1 .34-.34.32.32 0 0 1 .34.33.34.34 0 0 1-.68.01Z'
          stroke='#EA1A1A'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M24 19.98V39M12.86 22.06l6.26 14.02m16.01-14.02-6.26 14.02m-15.9 3.35a.33.33 0 1 0 0-.66.33.33 0 0 0 0 .66Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M12.97 39.19a.09.09 0 1 0 0-.18.09.09 0 0 0 0 .18Zm-5.98 4.19a.33.33 0 1 0 0-.66.33.33 0 0 0 0 .66Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCelebrate
